import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, Spin, Icon } from 'antd';
import { matchPath, withRouter } from 'react-router';
import { Link, Route } from 'react-router-dom';

const loadingIcon = <Icon type="loading" style={{ fontSize: 12 }} spin />;


// Credit: https://github.com/ReactTraining/react-router/issues/4556#issuecomment-339424327
// Breadcumb items route
class Breadcrumbs extends Component {
    constructor(props) {
        super(props);

        this.routes = [
            {
                path: '/',
                render: () => 'Home'
            },
            {
                path: '/reader',
                render: () => 'QR Reader'
            },
            {
                path: '/:gender/angkatan/:angkatan/page/:page',
                render: props => `Halaman ${props.match.params.page}`
            },
            {
                path: '/:gender/angkatan/:angkatan',
                render: props => `Angkatan ${props.match.params.angkatan}`
            },
            {
                path: '/:gender',
                render: props => {
                    const { gender } = props.match.params;
                    let genderLabel = gender.charAt(0).toUpperCase() + gender.slice(1);
                    return genderLabel;
                }
            },
            {
                path: '/guests/:id',
                render: props => {
                    const { data } = this.props;
                    if ( 'nama' in data ) {
                        return data.nama;
                    }

                    return <Spin indicator={loadingIcon} />
                }
            }
        ];
    }

    getBreadcrumbs = ({location}) => {
        const matches = [];
        const { pathname } = location;

        pathname
            .replace(/\/$/, '')
            .split('/')
            .reduce((previous, current) => {
                const pathSection = `${previous}/${current}`;
                const match = this.routes.find(({ matchOptions, path }) =>
                    matchPath(pathSection, { ...(matchOptions || { exact: true }), path }));

                if (match) {
                    matches.push({
                        component: <Route {...match} />,
                        path: pathSection,
                    });
                }

                return pathSection;
            });

        return matches;
    }

    render() {
        const crumbs = this.getBreadcrumbs({ location: this.props.location });

        return (
            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item key="/">
                    <Link to="/">Home</Link>
                </Breadcrumb.Item>

                {crumbs.map(({ component, path }, index) => {
                    return (
                        <Breadcrumb.Item key={path}>
                            <Link to={path}>
                                {component}
                            </Link>
                        </Breadcrumb.Item>
                    );
                })}
            </Breadcrumb>
        )
    }
}

const mapStateToProps = (state) => {
    const { data } = state.guest;
    return { data };
}

export default withRouter(connect(mapStateToProps)(Breadcrumbs));


// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/index.js